export const profileReducerKey = 'profileReducerKey';
export const profileSetIsLoadingReducerType = 'profileSetIsLoadingReducerType';
export const profileSetInputDataReducerType = 'profileSetInputDataReducerType';
export const profileSetAllSalutationsReducerType = 'profileSetAllSalutationsReducerType';
